/* @flow */

import _HoverTooltip from './HoverTooltip';

export default _HoverTooltip;



// WEBPACK FOOTER //
// ./src/components/HoverTooltip/index.js